// Eagerly map all assets so SeoPage.heroImage strings resolve to bundled URLs.
const modules = import.meta.glob("/src/assets/**/*.{jpg,jpeg,png,webp}", {
  eager: true,
  query: "?url",
  import: "default",
}) as Record<string, string>;

export const resolveAssetPath = (relPath: string): string => {
  const key = `/src/assets/${relPath}`;
  return modules[key] || "";
};